// TELEFONIA — a conta sem tela da página Integrações › Telefonia (25/09/2026).

// 100–5999; 6XX para cima é reservado para serviços (eco 600, URA e filas).
export const NUMERO_DE_RAMAL = /^[1-5]\d{2,3}$/;

// O próximo número livre a partir do 101 (o que a recepção costuma ter).
export function proximoNumero(ramais = []) {
  const usados = new Set(ramais.map(r => Number(r.numero)));
  for (let n = 101; n <= 5999; n += 1) {
    if (n % 100 !== 0 && !usados.has(n)) return String(n);
  }
  return '';
}

// Onde o ramal está: no ar, parado, com defeito ou desligado.
export function estadoDoRamal(r) {
  if (!r.ativo) return 'desligado';
  if (r.erro || !r.no_pbx) return 'erro';
  return r.online ? 'online' : 'offline';
}

// "Zoiper rv2.10.20.4", "Linphone/5.2.0 (iPhone)", "baresip v1.0.0" → nome curto.
const APARELHOS = [
  [/zoiper/i, 'Zoiper'],
  [/linphone/i, 'Linphone'],
  [/microsip/i, 'MicroSIP'],
  [/grandstream/i, 'Grandstream'],
  [/yealink/i, 'Yealink'],
  [/bria|counterpath/i, 'Bria'],
  [/baresip/i, 'baresip'],
  [/advup/i, 'advup'],
];
export function aparelhoLegivel(agente = '') {
  if (!agente) return '';
  const achado = APARELHOS.find(([re]) => re.test(agente));
  return achado ? achado[1] : agente.split(/[\s/]/)[0];
}

// O texto que "Copiar tudo" leva para a área de transferência.
export function credenciaisEmTexto(c, rotulos) {
  return [
    `${rotulos.servidor}: ${c.servidor}`,
    `${rotulos.porta}: ${c.porta}`,
    `${rotulos.usuario}: ${c.usuario}`,
    `${rotulos.senha}: ${c.senha}`,
    `${rotulos.transporte}: ${c.transporte}`,
  ].join('\n');
}
